const sizes = {
    phoneSize:900
};

export default sizes;